import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductPriceRange.generated';
import { ProductVariantPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductVariantPriceRange.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductCardVariantsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  wholesale?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ProductCardVariantsQuery = { specific: { id: string, pk: number, name: string, product: { id: string, pk: number, isArchive: boolean, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, wholesalePriceRange?: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } } | null, variantsProperties: Array<{ pk: number, variation: number, attributeName: string, valueName: string, stockStatus: Types.OutOfStockStatusEnum, sortOrder: number | null, isSupply: boolean, shippingRequired: boolean }> } | null } | null };

export type ProductCardVariantQueryVariables = Types.Exact<{
  pk?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  productPk?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  wholesale?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ProductCardVariantQuery = { productVariant: { id: string, pk: number, isSupply: boolean, isCustomizable: boolean, hasDefaultKit: boolean, shippingRequired: boolean, stockQuantity: number, outOfStockStatus: Types.OutOfStockStatusEnum, stockStatus: Types.OutOfStockStatusEnum | null, isInCart: boolean, filesCount: number, cartQuantity?: number, cartLines?: Array<number>, defaultKitPrice: { currency: string, gross: number } | null, defaultKitWholesalePrice?: { currency: string, gross: number } | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, wholesalePrice?: { currency: string, undiscount: number, discount: number } } | null };


export const ProductCardVariantsDocument = gql`
    query ProductCardVariants($id: ID!, $wholesale: Boolean = false) {
  specific(id: $id) {
    id
    pk
    name
    product {
      id
      pk
      isArchive
      priceRange {
        ...ProductPriceRangeFragment
      }
      wholesalePriceRange @include(if: $wholesale) {
        ...ProductPriceRangeFragment
      }
      variantsProperties(isWholesale: $wholesale) {
        pk
        variation
        attributeName
        valueName
        stockStatus
        sortOrder
        isSupply
        shippingRequired
      }
    }
  }
}
    ${ProductPriceRangeFragmentDoc}`;

/**
 * __useProductCardVariantsQuery__
 *
 * To run a query within a React component, call `useProductCardVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCardVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCardVariantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      wholesale: // value for 'wholesale'
 *   },
 * });
 */
export function useProductCardVariantsQuery(baseOptions: Apollo.QueryHookOptions<ProductCardVariantsQuery, ProductCardVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCardVariantsQuery, ProductCardVariantsQueryVariables>(ProductCardVariantsDocument, options);
      }
export function useProductCardVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCardVariantsQuery, ProductCardVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCardVariantsQuery, ProductCardVariantsQueryVariables>(ProductCardVariantsDocument, options);
        }
export type ProductCardVariantsQueryHookResult = ReturnType<typeof useProductCardVariantsQuery>;
export type ProductCardVariantsLazyQueryHookResult = ReturnType<typeof useProductCardVariantsLazyQuery>;
export type ProductCardVariantsQueryResult = Apollo.QueryResult<ProductCardVariantsQuery, ProductCardVariantsQueryVariables>;
export function refetchProductCardVariantsQuery(variables: ProductCardVariantsQueryVariables) {
      return { query: ProductCardVariantsDocument, variables: variables }
    }
export const ProductCardVariantDocument = gql`
    query ProductCardVariant($pk: Int, $productPk: Int, $wholesale: Boolean = false) {
  productVariant(pk: $pk, productPk: $productPk) {
    id
    pk
    isSupply
    isCustomizable
    hasDefaultKit
    defaultKitPrice {
      currency
      gross
    }
    defaultKitWholesalePrice @include(if: $wholesale) {
      currency
      gross
    }
    shippingRequired
    stockQuantity
    outOfStockStatus
    stockStatus
    isInCart
    filesCount
    priceRange {
      ...ProductVariantPriceRangeFragment
    }
    wholesalePrice @include(if: $wholesale) {
      currency
      undiscount
      discount
    }
    cartQuantity(cartType: WHOLESALE) @include(if: $wholesale)
    cartLines(cartType: WHOLESALE) @include(if: $wholesale)
  }
}
    ${ProductVariantPriceRangeFragmentDoc}`;

/**
 * __useProductCardVariantQuery__
 *
 * To run a query within a React component, call `useProductCardVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCardVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCardVariantQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *      productPk: // value for 'productPk'
 *      wholesale: // value for 'wholesale'
 *   },
 * });
 */
export function useProductCardVariantQuery(baseOptions?: Apollo.QueryHookOptions<ProductCardVariantQuery, ProductCardVariantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCardVariantQuery, ProductCardVariantQueryVariables>(ProductCardVariantDocument, options);
      }
export function useProductCardVariantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCardVariantQuery, ProductCardVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCardVariantQuery, ProductCardVariantQueryVariables>(ProductCardVariantDocument, options);
        }
export type ProductCardVariantQueryHookResult = ReturnType<typeof useProductCardVariantQuery>;
export type ProductCardVariantLazyQueryHookResult = ReturnType<typeof useProductCardVariantLazyQuery>;
export type ProductCardVariantQueryResult = Apollo.QueryResult<ProductCardVariantQuery, ProductCardVariantQueryVariables>;
export function refetchProductCardVariantQuery(variables?: ProductCardVariantQueryVariables) {
      return { query: ProductCardVariantDocument, variables: variables }
    }